import ListContainers from "../../../../components/@repositories/containers/ListContainers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ContainersPage() {

    return (
        <ListContainers 
            routeType={routeTypes.admin}
        />
    )
}